// Logo Import
import logo from "../assets/images/logo/min-logo.svg";
import logoFull from "../assets/images/logo/assistive-logo.svg";

//new logo
import newLogo from "../assets/images/logo/new-logo.svg";
//new mini logo
import newMiniLogo from "../assets/images/logo/new-mini-logo.svg";

// You can customize the template with the help of this file
//const logo = require("@src/assets/images/logo/logo.svg");
//Template config options
const themeConfig = {
  
  app: {
    appName: "Assistive",
    appLogoImage: newMiniLogo,
    appLogoFull: newLogo
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: false,
    scrollTop: false, // Enable scroll to top button
    toastPosition: "top-center", // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  },
};

export default themeConfig;
